import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["carrier", "category"];

  filter() {
    const filters = {
      carrier: this.carrierTarget.value,
      category: this.categoryTarget.value
    };
    this.stimulate("CategoryTierFactorReflex#filter", filters);
  }
}
